module.exports = __webpack_public_path__ + "static/media/card-image-4.c3aa6251.jpg";